const WebSpeechRecognition = require('./src/WebSpeechRecognition');
const WebSocketClient = require("./src/WebSocketClient");
const WavRecorder = require("./src/WavRecorder");
const GSRecorder = require("./src/GSRecorder");

window.AudioContext = window.AudioContext || window.webkitAudioContext;

class SpeechRecorder {
    isMobile = false;
    recording = false;
    stream = null;
    audioContext = null;
    wavRecorder = null;
    gsRecorder = null;
    wsRecognition = null;
    webSocketClient = null;

    onData = () => { };
    transcript = null;
    audioBlob = null;

    constructor({
        isMobile, serverUrl, query,
        onInterimTranscript = console.log,
        onData = console.log,
        onError = console.error,
    }) {
        this.isMobile = isMobile;
        this.onData = onData;

        console.log("DEBUG::init ", { isMobile, serverUrl });

        this.audioContext = new AudioContext();

        this.wavRecorder = new WavRecorder(this.onAudio);

        if (isMobile) {
            this.webSocketClient = new WebSocketClient({
                url: serverUrl, query, onInterimTranscript, onError,
                onTranscript: this.onTranscript,
            });

            this.gsRecorder = new GSRecorder(this.webSocketClient.sendBinary);
        } else {
            this.wsRecognition = new WebSpeechRecognition(
                this.onTranscript,
                onInterimTranscript
            );
        }
    }

    onTranscript = (transcript) => {
        this.transcript = transcript;
        if (this.audioBlob !== null) {
            this.onData({ transcript, audioBlob: this.audioBlob });
            this.transcript = null;
            this.transcript = null;
        }
    }

    onAudio = (audioBlob) => {
        this.audioBlob = audioBlob;
        if (this.transcript !== null) {
            this.onData({ transcript: this.transcript, audioBlob });
            this.audioBlob = null;
            this.transcript = null;
        }
    }

    async initStream() {
        this.stream = await navigator.mediaDevices.getUserMedia({
            audio: true, video: false
        });
    }

    /**
     * Start the recording and generating speech
     * @returns {void}
     */
    async start() {
        if (this.recording) return;
        if (!this.stream) await this.initStream();
        if (this.audioContext.state === 'suspended') this.audioContext.resume();

        console.log('DEBUG::SpeechRecorder:started');

        this.transcript = null;
        this.audioBlob = null;
        this.wavRecorder.start(this.stream, this.audioContext);
        if (this.isMobile) {
            this.webSocketClient.start();
            this.gsRecorder.start(this.stream, this.audioContext);
        }
        else this.wsRecognition.start();

        this.recording = true;
    }

    /**
     * Stops the recording and generating speech
     * @returns {void}
     */
    stop(onData = console.log) {
        if (this.recording) {
            console.log('DEBUG::SpeechRecorder:stopped');

            this.onData = onData;

            this.wavRecorder.end();
            if (this.isMobile) {
                this.gsRecorder.end();
                this.webSocketClient.end();
            }
            else this.wsRecognition.stop();

            this.recording = false;
        }
    }

    destructor() {
        this.stream?.getTracks()?.forEach(track => track.stop());
        this.audioContext.close().then(() => {
            this.stream = null;
            this.audioContext = null;
        });
    }
}

module.exports = SpeechRecorder;